module.exports = __webpack_public_path__ + "img/ShowerRain.6161a0cd.png";